import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../global/sub-window/common/common-close-sub-window-buttons';
import { PassportField } from '../../../../_events/_manage-event/_edit-website/website-form-body/passport-field/passport-field';
import { OrderBookingEmailsListVM } from './order-booking-emails-list.viewmodel';
import { CONFIGURE_TEXT } from '../../../../../constants/common-labels.constants';
import { DONE_TEXT } from './order-booking-emails.texts';

interface IProps {
    vm: OrderBookingEmailsListVM;
    intl: IntlShape;
}

export const OrderBookingEmailsListPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { vm, intl } = props;

    if (vm.loading) {
        return (
            <CommonPopupBodyFooterLayout
                body={
                    <div className='oe-form'>
                        {intl.formatMessage({
                            id: 'oe.blueprint.orderBooking.emailsLoading',
                            description: 'Loading order booking emails',
                            defaultMessage: 'Loading Order Booking emails...',
                        })}
                    </div>
                }
            />
        );
    }

    return (
        <CommonPopupBodyFooterLayout
            className='oe-form'
            body={
                <div className='email-templates-form oe-form-body'>
                    {vm.configurations.map(configuration => (
                        <div key={configuration.type} className='email-templates-item'>
                            <PassportField
                                className='email-templates-form--title'
                                onClick={() => vm.showConfigureEmail(configuration)}
                                buttonText={intl.formatMessage(CONFIGURE_TEXT)}
                                rowText={vm.getEmailLabel(configuration)}
                            />
                        </div>
                    ))}
                </div>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton text={intl.formatMessage(DONE_TEXT)} />
                </div>
            }
        />
    );
}));
